import React, { ReactNode } from 'react'

interface Props {
    children: ReactNode
}
const Content = ({ children }: Props) => {
    return (
        <main className="flex-1">
            <div className="p-[44px] w-full h-full flex flex-col gap-6">{children}</div>
        </main>
    )
}

export default Content
